{
  "title": "المبالغ المستردة",
  "subtitle": "أرصدة استردها العملاء من حساب نقدية أو بنك.",
  "new": "استرداد الرصيد",
  "newTitle": "استرداد رصيد العميل",
  "newSubtitle": "يُصرف المبلغ المسترد للعميل ويُرحَّل إلى الدفاتر فورًا. يُعيَّن الرقم عند الحفظ.",
  "kind": "مبلغ مسترد",
  "save": "تسجيل الاسترداد",
  "searchLabel": "البحث في المبالغ المستردة",
  "searchPlaceholder": "ابحث بالرقم أو المرجع أو العميل…",
  "chooseAccount": "اختر حساب النقدية أو البنك",
  "chooseCustomerFirst": "اختر العميل لعرض رصيده غير المستخدم.",
  "voidTitle": "هذا الاسترداد مُبطَل",
  "sections": {
    "refund": "الاسترداد",
    "credits": "رصيد غير مستخدم",
    "applications": "الرصيد المسترد",
    "payment": "الدفع"
  },
  "fields": {
    "date": "تاريخ الاسترداد",
    "account": "مدفوع من",
    "method": "طريقة الدفع",
    "amount": "المبلغ المسترد",
    "recordedAt": "تاريخ التسجيل",
    "source": "الرصيد",
    "sourceDate": "التاريخ",
    "available": "غير مستخدم",
    "refundAmount": "المبلغ المسترد",
    "total": "إجمالي الاسترداد",
    "from": "من"
  },
  "source": {
    "RECEIPT": "سند قبض",
    "CREDIT_NOTE": "إشعار دائن"
  },
  "hints": {
    "reference": "رقم الشيك أو التحويل.",
    "credits": "سندات القبض والإشعارات الدائنة لهذا العميل التي لم تُطبَّق بالكامل على الفواتير. استرد الرصيد كله أو جزءًا منه.",
    "noAccounts": "لا يوجد حساب نقدية أو بنك نشط. اطلب من المسؤول إضافة حساب من المحاسبة › النقدية والبنوك."
  },
  "credits": {
    "tableLabel": "رصيد غير مستخدم",
    "refundAll": "استرداد الكل",
    "clear": "مسح المبالغ",
    "none": "ليس لهذا العميل رصيد غير مستخدم.",
    "noneBody": "يظهر الرصيد هنا عندما لا يُطبَّق سند قبض أو إشعار دائن على الفواتير بالكامل.",
    "limited": "تُعرض أحدث {{n}} من المستندات التي فيها رصيد غير مستخدم فقط.",
    "overAvailable": "المبلغ أكبر من الرصيد المتبقي.",
    "afterRefund": "تاريخه بعد تاريخ الاسترداد. غيّر تاريخ الاسترداد.",
    "amountOf": "المبلغ المراد استرداده من {{number}}",
    "summary": "يسترد العميل {{amount}}."
  },
  "errors": {
    "noCredit": "أدخل مبلغًا للاسترداد من سند قبض أو إشعار دائن واحد على الأقل.",
    "overAvailable": "أحد المبالغ أكبر من الرصيد المتبقي في مصدره. خفّضه.",
    "afterRefund": "أحد الأرصدة مؤرخ بعد تاريخ الاسترداد. غيّر تاريخ الاسترداد أو استبعد هذا الرصيد.",
    "REFUND_EXCEEDS_CREDIT": "أحد المبالغ أكبر مما تبقى للاسترداد في مصدره.",
    "WALK_IN_NO_CREDIT": "العميل النقدي لا يحتفظ برصيد، لذا لا يمكن إبطال هذا الاسترداد وحده."
  },
  "actions": {
    "refund": "استرداد الرصيد",
    "void": "إبطال الاسترداد"
  },
  "void": {
    "title": "إبطال {{number}}؟",
    "body": "يعود الرصيد إلى سندات القبض والإشعارات الدائنة التي أُخذ منها، ويُعكس القيد اليومي. يبقى الاسترداد مسجلًا وعليه علامة الإبطال."
  },
  "toast": {
    "created": "سُجّل الاسترداد {{number}}",
    "voided": "أُبطِل {{number}}"
  },
  "empty": {
    "title": "لا توجد مبالغ مستردة بعد.",
    "body": "سجّل ما يسترده العميل من رصيده المتبقي في سندات القبض والإشعارات الدائنة.",
    "void": "لا توجد استردادات ملغاة."
  },
  "tillDocument": {
    "title": "صادر من نقطة البيع",
    "body": "صُرف هذا المبلغ المسترد من الصندوق مقابل مرتجع في نقطة البيع، لذا لا يُبطَل من هنا."
  },
  "views": {
    "label": "عروض الاستردادات",
    "all": "الكل",
    "void": "الملغاة",
    "paidOut": "المدفوع"
  },
  "stats": {
    "label": "أرقام الاستردادات",
    "paidOut": "المدفوع",
    "credit": "رصيد قابل للاسترداد",
    "creditDetail": "{{receipts}} · {{notes}}",
    "creditAll": "كل العملاء",
    "unavailable": "الأرقام غير متاحة",
    "void": "الملغاة",
    "voidDetail": "ملغاة، وأُعيد الرصيد",
    "refunds_zero": "لا استردادات",
    "refunds_one": "استرداد واحد",
    "refunds_two": "استردادان",
    "refunds_few": "{{n}} استردادات",
    "refunds_many": "{{n}} استردادًا",
    "refunds_other": "{{n}} استرداد",
    "receipts_zero": "لا سندات قبض",
    "receipts_one": "سند قبض واحد",
    "receipts_two": "سندا قبض",
    "receipts_few": "{{n}} سندات قبض",
    "receipts_many": "{{n}} سند قبض",
    "receipts_other": "{{n}} سند قبض",
    "notes_zero": "لا إشعارات دائنة",
    "notes_one": "إشعار دائن واحد",
    "notes_two": "إشعاران دائنان",
    "notes_few": "{{n}} إشعارات دائنة",
    "notes_many": "{{n}} إشعارًا دائنًا",
    "notes_other": "{{n}} إشعار دائن"
  }
}
